/* eslint-disable @typescript-eslint/no-unused-vars */
import { Checkbox, Input, Modal, Radio, Row, Select, TreeSelect } from 'antd';
import { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import { classAction } from 'redux/action/classAction';
import { customerOptionsAction } from 'redux/action/customerAction';
import { getEmployeeAction } from 'redux/action/employeeAction';
import { postApi, putApi } from 'redux/apis';
import { AppDispatch } from 'redux/store';
import { CloseSvg, DeleteActionSvg } from 'utils/svgs';
import { checkPermission, hasText, toastText } from 'utils/utils';
import styles from './index.module.scss';
import './index.scss';
import { payPeriodOptionsAction } from 'redux/action/payPeriodAction';
import { getConfiguration } from 'redux/action/configurationAction';
import { MAX_CUSTOM_RULE_CRITERIA_VALUES } from 'constants/Data';
import { RuleCriteria } from '../types';

const normalizeOptionalCriteriaValue = (value: any): 'ANY' | '' | string[] => {
	if (Array.isArray(value)) return value;
	if (value === 'ANY' || value === '' || value === null || value === undefined) {
		return value === 'ANY' ? 'ANY' : '';
	}
	return [value];
};

const normalizeEmployeeCriteriaValue = (value: any): 'ANY' | string[] => {
	if (value === 'ANY') return 'ANY';
	if (Array.isArray(value)) return value;
	if (value) return [value];
	return 'ANY';
};

const normalizeCriteria = (rawCriteria: any): RuleCriteria => {
	return {
		...rawCriteria,
		employeeId: normalizeEmployeeCriteriaValue(rawCriteria?.employeeId),
		customerId: normalizeOptionalCriteriaValue(rawCriteria?.customerId),
		classId: normalizeOptionalCriteriaValue(rawCriteria?.classId),
	};
};

interface Props {
	handleCloseModal: () => void;
	isModalOpen: boolean;
	modalData: any;
	getCustomRulesData: (value: string) => void;
	isCopy: boolean | null | undefined;
	modalKey: string;
}

const AddRuleModal = (props: Props) => {
	const {
		handleCloseModal,
		isModalOpen,
		modalData,
		getCustomRulesData,
		isCopy,
		modalKey,
	} = props;

	const { TextArea } = Input;
	const dispatch = useDispatch<AppDispatch>();

	const { optionData: customerList } = useSelector(
		(state: any) => state.customer
	);

	const { data: classList } = useSelector((state: any) => state.class);
	const { data: employeeList } = useSelector((state: any) => state.employees);

	const fetchData = () => {
		dispatch(classAction());
		dispatch(customerOptionsAction());
		dispatch(getEmployeeAction());
		dispatch(payPeriodOptionsAction());
	};

	const payPeriods = useSelector((state: any) => state?.payPeriods?.optionData);

	useEffect(() => {
		fetchData();

		let payPeriodId = localStorage.getItem('payPeriod');

		if (!payPeriodId) {
			if (payPeriods && payPeriods.length) {
				payPeriodId = payPeriods[payPeriods.length - 1].id;
			}
		}

		if (payPeriodId) {
			dispatch(
				getConfiguration({
					payPeriodId,
				})
			);
		}
	}, []);

	const [isLoading, setIsLoading] = useState(false);

	const [data, setData] = useState<any>({
		name: '',
		description: '',
		isActive: true,
		triggerProcess:
			modalKey === '1'
				? 'split'
				: modalKey === '2'
				? 'edit'
				: 'delete' || 'split',
	});

	const [criteria, setCriteria] = useState<RuleCriteria>({
		employeeId: 'ANY',
		classId: '',
		customerId: '',
		operator1: 'AND',
		operator2: 'AND',
	});

	const [actions, setActions] = useState([
		{
			key: Math.random(),
			employeeId: '',
			hours: 50,
			customerId: '',
			customerName: '',
			classId: '',
			className: '',
		},
		{
			key: Math.random(),
			employeeId: '',
			hours: 50,
			customerId: '',
			customerName: '',
			classId: '',
			className: '',
		},
	]);

	const [editActions, setEditActions] = useState({
		key: Math.random().toString(),
		employeeId: '',
		hours: '00:00',
		customerId: '',
		customerName: '',
		classId: '',
		className: '',
	});
	const [isEdit, setIsEdit] = useState(modalKey === '2' ? true : false);
	const [isSplit, setIsSplit] = useState(modalKey === '1' ? true : false);

	const [finalCustomerList, setFinalCustomerList] = useState<any>([]);
	const [isError, setIsError] = useState(false);
	const [isHoursError, setIsHoursError] = useState(false);
	const [total, setTotal] = useState(100);
	const [validation, setValidation] = useState({
		name: false,
		employeeId: false,
		classId: false,
		customerId: false,
	});
	const [editValidation, setEditValidation] = useState({
		employeeId: false,
		classId: false,
		customerId: false,
	});

	const [filteredClassList, setFilteredClassList] = useState([]);

	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);
	const isAddRulePermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Custom Rules',
		permission: ['add'],
	});

	const isEditRulePermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Custom Rules',
		permission: ['edit'],
	});

	const { data: configurations } = useSelector(
		(state: any) => state?.configuration
	);

	const handleTrigger = (value: string) => {
		if (value === 'edit') {
			setIsEdit(true);
			setIsSplit(false);
		} else if (value === 'split') {
			setIsEdit(false);
			setIsSplit(true);
		} else if (value === 'delete') {
			setIsEdit(false);
			setIsSplit(false);
		}

		setData((prev: any) => {
			return {
				...prev,
				triggerProcess: value,
			};
		});
	};

	useEffect(() => {
		if (modalData) {
			setData({
				name: modalData?.name,
				description: modalData?.description,
				isActive: modalData?.isActive ? true : false,
				triggerProcess: modalData?.triggerProcess,
			});
			setCriteria(normalizeCriteria(modalData.criteria));
			if (isEdit) {
				setEditActions(modalData.actions[0]);
			} else {
				setActions(modalData.actions);
			}
		}
	}, [modalData]);

	useEffect(() => {
		if (customerList && customerList.length > 0) {
			const newCustomers = [...customerList];
			newCustomers.shift();
			const finalData = [
				{
					value: '',
					title: 'Blank Customer',
					children: [],
				},
				{
					value: 'ANY',
					title: 'Any Customer',
					children: [],
				},
				...newCustomers,
			];
			setFinalCustomerList(finalData);
		}
	}, [customerList]);

	useEffect(() => {
		if (
			configurations &&
			configurations.settings &&
			classList &&
			classList.length
		) {
			const filteredClass = classList.filter((singleClass: any) => {
				return singleClass.Id !== configurations.settings[0].fields['f1'].value;
			});
			setFilteredClassList(filteredClass);
		}
	}, [configurations, classList]);

	const handleInput = (e: any) => {
		let value = e.target.value;
		if (e.target.name == 'name') {
			if (!hasText(value)) {
				setValidation((prev) => {
					return {
						...prev,
						name: true,
					};
				});

				setIsError(true);
			} else {
				setValidation((prev) => {
					return {
						...prev,
						name: false,
					};
				});

				setIsError(false);
			}
		}

		if (e.target.name == 'isActive') {
			value = e.target.checked;
		}

		setData((prev: any) => {
			return {
				...prev,
				[e.target.name]: value,
			};
		});
	};

	const handleCriteriaSentinel = (
		name: 'employeeId' | 'customerId' | 'classId',
		value: 'ANY' | ''
	) => {
		setCriteria((prev) => ({
			...prev,
			[name]: value,
		}));

		if (name === 'employeeId') {
			setValidation((prev) => ({ ...prev, employeeId: false }));
			setIsError(false);
		}
	};

	const handleCriteriaMultiSelect = (
		name: 'employeeId' | 'customerId' | 'classId',
		values: string[]
	) => {
		if (values.length > MAX_CUSTOM_RULE_CRITERIA_VALUES) {
			toastText(
				`Maximum ${MAX_CUSTOM_RULE_CRITERIA_VALUES} values allowed per field`,
				'error'
			);
			return;
		}

		const nextValue = values.length === 0 ? 'ANY' : values;

		setCriteria((prev) => ({
			...prev,
			[name]: nextValue,
		}));

		if (name === 'employeeId') {
			setValidation((prev) => ({ ...prev, employeeId: false }));
			setIsError(false);
		}
	};

	// Actions table shows the rule's employee(s) in a single read-only cell
	// (rowSpan across split/edit rows) rather than repeating a Select per row.
	const getSelectedEmployeeNames = () => {
		if (criteria.employeeId === 'ANY') return 'Any Employee';
		if (Array.isArray(criteria.employeeId) && criteria.employeeId.length) {
			return criteria.employeeId
				.map(
					(id) =>
						employeeList?.find((employee: any) => employee?.id === id)
							?.fullName
				)
				.filter(Boolean)
				.join(', ');
		}
		return '';
	};

	// The criteria customer TreeSelect below must not offer "Blank
	// Customer"/"Any Customer" as multi-select options (those are the
	// dedicated sentinel buttons instead) — but finalCustomerList is shared
	// with the per-action customer pickers further down, which still need
	// those two synthetic entries, so filter only for this instance.
	const criteriaCustomerTreeData = finalCustomerList.filter(
		(node: any) => node.value !== '' && node.value !== 'ANY'
	);

	const handleOperator = (value: string, name: string) => {
		setCriteria((prev) => {
			const _query = {
				...prev,
				[name]: value,
			};

			return _query;
		});

		if (name === 'operator1' && value === 'NONE') {
			setCriteria((prev) => {
				return {
					...prev,
					customerId: '',
				};
			});
		}

		if (name === 'operator2' && value === 'NONE') {
			setCriteria((prev) => {
				return {
					...prev,
					classId: '',
				};
			});
		}
	};

	const addAnotherItem = () => {
		const length = actions.length + 1;
		const hours = Number(100 / length).toFixed(2);

		const diff = Number((100 - Number(hours) * length).toFixed(2));

		const lastHours = (
			diff && diff > 0 ? Number(hours) + diff : Number(hours) - Math.abs(diff)
		).toFixed(2);

		const data = {
			key: Math.random(),
			employeeId: '',
			hours: lastHours,
			customerId: '',
			customerName: '',
			classId: '',
			className: '',
		};

		const finalArr = actions.map((item: any) => {
			return {
				...item,
				hours: Number(hours),
			};
		});
		finalArr.push(data);
		setActions(finalArr);
	};

	const handleDeleteRow = (id: string) => {
		const _actions = JSON.parse(JSON.stringify(actions));
		const length = _actions.length - 1;
		const hours = Number(100 / length).toFixed(2);

		const diff = Number((100 - Number(hours) * length).toFixed(2));

		const lastHours = (
			diff && diff > 0 ? Number(hours) + diff : Number(hours) - Math.abs(diff)
		).toFixed(2);

		const finalArr = _actions.filter((action: any) => action.key !== id);
		finalArr.forEach((item: any, index: number) => {
			if (index == finalArr.length - 1) {
				item.hours = lastHours;
			} else {
				item.hours = hours;
			}
		});
		setActions(finalArr);
	};

	const handleActions = (
		name: string,
		value: string,
		key: string,
		nameLabel?: string,
		nameValue?: string
	) => {
		if (isEdit) {
			setEditActions((prev) => {
				const query: any = {
					...prev,
					[name]: value,
				};
				if (nameLabel && nameValue) {
					query[nameLabel] = nameValue;
				}
				return query;
			});
		} else {
			const _actions = actions;

			let _value: string | number = value;

			if (name === 'hours') {
				_value = value ? Number(value) : 0;
				const filtered = _actions.filter((item: any) => item.key !== key);
				let hours = 0;

				filtered.forEach((item) => {
					hours += Number(Number(item.hours).toFixed(2));
				});
				const totalHours = Number((Number(hours) + Number(_value)).toFixed(2));
				setTotal(totalHours);
				if (totalHours != 100) {
					setIsHoursError(true);
					setIsError(true);
				} else {
					setIsHoursError(false);
					setIsError(false);
				}
			}

			const finalArr = _actions.map((item: any) => {
				if (item.key === key) {
					const query = {
						...item,
						[name]: _value,
					};
					if (nameLabel && nameValue) {
						query[nameLabel] = nameValue;
					}
					return query;
				} else {
					return item;
				}
			});

			setActions(finalArr);
		}
	};

	const checkAllValidation = () => {
		let isValidation = true;
		const isNameValid = hasText(data.name);
		const isEmployeeValid = hasText(criteria.employeeId);

		if (!isNameValid || !isEmployeeValid) {
			setValidation({
				...validation,
				name: !isNameValid,
				employeeId: !isEmployeeValid,
			});
			isValidation = false;
		}

		if (isEdit) {
			if (
				configurations.isClassRequiredForJournal &&
				editActions.classId === ''
			) {
				setEditValidation((prev) => {
					return {
						...prev,
						classId: true,
					};
				});

				isValidation = false;
			}
			if (
				configurations.isCustomerRequiredForJournal &&
				editActions.customerId === ''
			) {
				setEditValidation((prev) => {
					return {
						...prev,
						customerId: true,
					};
				});
				isValidation = false;
			}
		} else {
			setEditValidation({
				classId: false,
				customerId: false,
				employeeId: false,
			});
		}

		return isValidation;
	};

	const handleSubmit = async () => {
		try {
			const invalidation = checkAllValidation();
			if (invalidation) {
				setIsLoading(true);
				let response: any;
				if (modalData && !isCopy) {
					response = await putApi(`/custom-rule/${modalData.id}`, {
						companyId: localStorage.getItem('companyId'),
						...data,
						criteria: criteria,
						actions: isEdit ? [editActions] : actions,
					});
				} else {
					response = await postApi(`/custom-rule`, {
						companyId: localStorage.getItem('companyId'),
						...data,
						criteria: criteria,
						actions: isEdit ? [editActions] : actions,
					});
				}
				setIsLoading(false);
				toastText(response?.data?.message, 'success');
				handleCloseModal();
				getCustomRulesData(data?.triggerProcess);
			}
		} catch (err: any) {
			if (err.response.data.message) {
				toastText(err.response.data.message, 'error');
			} else {
				toastText('Something went wrong', 'error');
			}
			setIsLoading(false);
		}
	};

	return (
		<div className={styles['rule-modal-container']}>
			<Modal
				open={isModalOpen}
				onCancel={handleCloseModal}
				className="preview-container"
				closable={false}
				style={{
					borderRadius: 0,
				}}
				footer={[]}
			>
				<div>
					<Row className={styles['preview-container__top']}>
						<div className={styles['preview-container__top-title']}>
							<b> {modalData && !isCopy ? 'Edit' : 'Add'} Time Rules</b>
						</div>
						<div
							className={styles['preview-container__top-close']}
							onClick={handleCloseModal}
						>
							<CloseSvg />
						</div>
					</Row>
				</div>
				<div
					className={`${styles['preview-container__main']} preview-container__main`}
				>
					<div className={styles['preview-container__main-add-rule']}>
						<div className={styles['preview-container__main-title']}>
							{modalData && !isCopy ? 'Edit' : 'Add'} Rule
						</div>
						<div
							className={styles['preview-container__main-add-rule__content']}
						>
							<div className={styles['preview-container__main-input-multiple']}>
								<div
									className={styles['preview-container__main-input-container']}
								>
									<label className={styles['preview-container__main-label']}>
										Rule Name <span className="text-danger">*</span>
									</label>
									<Input
										className={`${styles['preview-container__main-input']} ${
											validation.name &&
											styles['preview-container__main-input-error']
										} ${styles['input-field']}`}
										value={data.name}
										name="name"
										onChange={handleInput}
									/>
								</div>
								<div
									className={`${styles['preview-container__main-input-container']} ${styles['preview-container__main-checkbox']}`}
								>
									<Checkbox
										checked={data.isActive}
										name="isActive"
										onChange={handleInput}
									/>
									<label className={styles['preview-container__main-label']}>
										Is Active
									</label>
								</div>
							</div>

							<div
								className={styles['preview-container__main-input-container']}
							>
								<label className={styles['preview-container__main-label']}>
									Description
								</label>
								<TextArea
									className={`${styles['preview-container__main-input ']} ${styles['input-field']}`}
									rows={2}
									value={data.description}
									name="description"
									onChange={handleInput}
									maxLength={300}
								/>
							</div>
						</div>
					</div>
					<div className={styles['preview-container__main-trigger-process']}>
						<div className={styles['preview-container__main-title']}>
							Trigger Process
						</div>
						<div className={styles['preview-container__main-second-title']}>
							Execute based on action
						</div>

						<div
							className={styles['preview-container__main-add-rule__content']}
						>
							<Radio.Group
								className={styles['preview-container__main-radio']}
								value={data.triggerProcess}
								onChange={(e) => handleTrigger(e.target.value)}
							>
								<Radio value={'split'} style={{ fontSize: '12px' }}>
									Split
								</Radio>
								<Radio value={'delete'} style={{ fontSize: '12px' }}>
									Delete
								</Radio>
								<Radio value={'edit'} style={{ fontSize: '12px' }}>
									Edit
								</Radio>
							</Radio.Group>
						</div>
					</div>
					<div className={styles['preview-container__main-criteria']}>
						<div className={styles['preview-container__main-title']}>
							Criteria
						</div>
						<div
							className={styles['preview-container__main-add-rule__content']}
						>
							<div
								className={styles['preview-container__main-input-container']}
							>
								<label className={styles['preview-container__main-label']}>
									1. Employee Name <span className="text-danger">*</span>
								</label>
								<div style={{ width: '100%' }}>
									<Select
										className={`${styles['preview-container__main-input']} ${
											validation.employeeId &&
											'preview-container__main-input-error'
										}`}
										mode="multiple"
										maxTagCount="responsive"
										optionFilterProp="children"
										placeholder="Select Employee(s)"
										value={
											Array.isArray(criteria.employeeId)
												? criteria.employeeId
												: []
										}
										size="large"
										onChange={(values: string[]) =>
											handleCriteriaMultiSelect('employeeId', values)
										}
									>
										{employeeList?.map((employee: any, index: number) => {
											return (
												<Select.Option value={employee?.id} key={index}>
													{employee?.fullName}
												</Select.Option>
											);
										})}
									</Select>
									<div className={styles['preview-container__main-pill-row']}>
										<button
											type="button"
											className={`${
												styles['preview-container__main-operator-button']
											} ${
												criteria.employeeId === 'ANY' &&
												styles['preview-container__main-operator-button-active']
											}`}
											onClick={() => handleCriteriaSentinel('employeeId', 'ANY')}
										>
											Any Employee
										</button>
									</div>
								</div>
							</div>
							<div
								className={styles['preview-container__main-input-container']}
							>
								<label
									className={styles['preview-container__main-label']}
								></label>
								<div
									className={`${styles['preview-container__main-input']} ${styles['preview-container__main-operator']}`}
								>
									<button
										className={`${
											styles['preview-container__main-operator-button']
										} ${
											criteria.operator1 === 'AND' &&
											styles['preview-container__main-operator-button-active']
										}`}
										onClick={() => handleOperator('AND', 'operator1')}
									>
										AND
									</button>
									<button
										className={`${
											styles['preview-container__main-operator-button']
										} ${
											criteria.operator1 === 'OR' &&
											styles['preview-container__main-operator-button-active']
										}`}
										onClick={() => handleOperator('OR', 'operator1')}
									>
										OR
									</button>
									{/* <button
										className={`${
											styles['preview-container__main-operator-button']
										} ${
											criteria.operator1 === 'NONE' &&
											styles['preview-container__main-operator-button-active']
										}`}
										onClick={() => handleOperator('NONE', 'operator1')}
									>
										NONE
									</button> */}
								</div>
							</div>
							<div
								className={styles['preview-container__main-input-container']}
							>
								<label className={styles['preview-container__main-label']}>
									2. Customer
								</label>
								<div style={{ width: '100%' }}>
									<TreeSelect
										className={`${styles['preview-container__main-input']} ${
											validation.customerId &&
											'preview-container__main-input-error'
										}`}
										dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
										size="large"
										placeholder="Select Customer(s)"
										multiple
										maxTagCount="responsive"
										value={
											Array.isArray(criteria.customerId)
												? criteria.customerId
												: []
										}
										showSearch={true}
										treeData={criteriaCustomerTreeData}
										treeDefaultExpandAll
										onChange={(values: string[]) =>
											handleCriteriaMultiSelect('customerId', values)
										}
										filterTreeNode={(inputValue, treeNode) => {
											// Customize the filtering logic here
											return treeNode.props.title
												.toLowerCase()
												.includes(inputValue.toLowerCase());
										}}
									/>
									<div className={styles['preview-container__main-pill-row']}>
										<button
											type="button"
											className={`${
												styles['preview-container__main-operator-button']
											} ${
												criteria.customerId === '' &&
												styles['preview-container__main-operator-button-active']
											}`}
											onClick={() => handleCriteriaSentinel('customerId', '')}
										>
											Blank Customer
										</button>
										<button
											type="button"
											className={`${
												styles['preview-container__main-operator-button']
											} ${
												criteria.customerId === 'ANY' &&
												styles['preview-container__main-operator-button-active']
											}`}
											onClick={() => handleCriteriaSentinel('customerId', 'ANY')}
										>
											Any Customer
										</button>
									</div>
								</div>
							</div>
							<div
								className={styles['preview-container__main-input-container']}
							>
								<label
									className={styles['preview-container__main-label']}
								></label>
								<div
									className={`${styles['preview-container__main-input']} ${styles['preview-container__main-operator']}`}
								>
									<button
										className={`${
											styles['preview-container__main-operator-button']
										} ${
											criteria.operator2 === 'AND' &&
											styles['preview-container__main-operator-button-active']
										}`}
										onClick={() => handleOperator('AND', 'operator2')}
									>
										AND
									</button>
									<button
										className={`${
											styles['preview-container__main-operator-button']
										} ${
											criteria.operator2 === 'OR' &&
											styles['preview-container__main-operator-button-active']
										}`}
										onClick={() => handleOperator('OR', 'operator2')}
									>
										OR
									</button>
									{/* <button
										className={`${
											styles['preview-container__main-operator-button']
										} ${
											criteria.operator2 === 'NONE' &&
											styles['preview-container__main-operator-button-active']
										}`}
										onClick={() => handleOperator('NONE', 'operator2')}
									>
										NONE
									</button> */}
								</div>
							</div>
							<div
								className={styles['preview-container__main-input-container']}
							>
								<label className={styles['preview-container__main-label']}>
									3. Class
								</label>
								<div style={{ width: '100%' }}>
									<Select
										className={`${styles['preview-container__main-input']} ${
											validation.classId && 'preview-container__main-input-error'
										}`}
										mode="multiple"
										maxTagCount="responsive"
										optionFilterProp="children"
										placeholder="Select Class(es)"
										value={
											Array.isArray(criteria.classId) ? criteria.classId : []
										}
										size="large"
										onChange={(values: string[]) =>
											handleCriteriaMultiSelect('classId', values)
										}
									>
										{classList?.map((singleClass: any, index: number) => {
											return (
												<Select.Option value={singleClass?.Id} key={index}>
													{singleClass?.FullyQualifiedName}
												</Select.Option>
											);
										})}
									</Select>
									<div className={styles['preview-container__main-pill-row']}>
										<button
											type="button"
											className={`${
												styles['preview-container__main-operator-button']
											} ${
												criteria.classId === '' &&
												styles['preview-container__main-operator-button-active']
											}`}
											onClick={() => handleCriteriaSentinel('classId', '')}
										>
											Blank Class
										</button>
										<button
											type="button"
											className={`${
												styles['preview-container__main-operator-button']
											} ${
												criteria.classId === 'ANY' &&
												styles['preview-container__main-operator-button-active']
											}`}
											onClick={() => handleCriteriaSentinel('classId', 'ANY')}
										>
											Any Class
										</button>
									</div>
								</div>
							</div>
							<div
								className={styles['preview-container__main-input-container']}
							>
								<label className={styles['preview-container__main-label']}>
									Criteria Pattern
								</label>
								<p className={styles['preview-container__main-input']}>
									{criteria.employeeId && 1}{' '}
									{criteria.operator1 !== 'NONE' && `${criteria.operator1} 2`}{' '}
									{criteria.operator2 !== 'NONE' && `${criteria.operator2} 3`}
								</p>
							</div>
						</div>
					</div>
					{criteria?.employeeId && (
						<div className={styles['preview-container__main-actions']}>
							<div className={styles['preview-container__main-title']}>
								Actions
							</div>
							<div className={styles['preview-container__main-second-title']}>
								(Select one or more processes to be automatically triggered when
								a certain action is performed.)
							</div>
							{isSplit && (
								<div
									className={
										styles['preview-container__main-add-rule__content']
									}
								>
									<table className={styles['preview-container__main-table']}>
										<thead>
											<tr
												className={styles['preview-container__main-table-row']}
											>
												<th>Employee</th>
												<th>% of Hours</th>
												<th>Customers</th>
												<th>Class</th>
												{actions.length > 2 && <th>Action</th>}
											</tr>
										</thead>
										<tbody>
											{actions.map((action: any, index: number) => {
												return (
													<tr
														className={
															styles['preview-container__main-table-row']
														}
														key={action.key}
													>
														{!index ? (
															<td
																rowSpan={actions.length}
																style={{
																	width: '20%',
																}}
															>
																{getSelectedEmployeeNames()}
															</td>
														) : null}
														<td
															style={{
																width: '20%',
															}}
														>
															<NumericFormat
																value={action.hours}
																decimalScale={2}
																customInput={Input}
																fixedDecimalScale={true}
																suffix="%"
																className={`${
																	styles[
																		`${
																			isHoursError &&
																			'preview-container__main-input-error'
																		}`
																	]
																} ${styles['input-field']}`}
																onValueChange={(values: any) =>
																	handleActions(
																		'hours',
																		values.floatValue,
																		action.key
																	)
																}
															/>
														</td>
														<td
															style={{
																width: '30%',
															}}
														>
															<TreeSelect
																className={
																	styles['preview-container__main-input']
																}
																dropdownStyle={{
																	maxHeight: 400,
																	overflow: 'auto',
																}}
																size="large"
																placeholder="Customer"
																value={action.customerId}
																showSearch={true}
																treeData={finalCustomerList}
																treeDefaultExpandAll
																onChange={(value: any, data: any) => {
																	handleActions(
																		'customerId',
																		value,
																		action.key,
																		'customerName',
																		data[0]
																	);
																}}
																filterTreeNode={(inputValue, treeNode) => {
																	// Customize the filtering logic here
																	return treeNode.props.title
																		.toLowerCase()
																		.includes(inputValue.toLowerCase());
																}}
															/>
														</td>
														<td
															style={{
																width: '30%',
															}}
														>
															<Select
																className={
																	styles['preview-container__main-input']
																}
																value={action.classId}
																size="large"
																onChange={(value: any, data: any) => {
																	handleActions(
																		'classId',
																		value,
																		action.key,
																		'className',
																		data.children
																	);
																}}
															>
																{/* <Select.Option value="">
																	Select Class
																</Select.Option> */}
																<Select.Option value="">
																	Blank Class
																</Select.Option>
																{filteredClassList?.map(
																	(singleClass: any, index: number) => {
																		return (
																			<Select.Option
																				value={singleClass?.Id}
																				key={index}
																			>
																				{singleClass?.FullyQualifiedName}
																			</Select.Option>
																		);
																	}
																)}
															</Select>
														</td>
														{actions.length > 2 && (
															<td>
																<span
																	onClick={() => handleDeleteRow(action.key)}
																	className={
																		styles[
																			'preview-container__main-table-delete'
																		]
																	}
																>
																	<DeleteActionSvg />
																</span>
															</td>
														)}
													</tr>
												);
											})}
											<tr
												className={`${styles['preview-container__main-table-row']} ${styles['preview-container__main-table-end']}`}
											>
												<td></td>
												<td>Total {total}%</td>
												<td></td>
												<td>
													<span
														onClick={addAnotherItem}
														className={
															styles['preview-container__main-table-add']
														}
													>
														+ Add Another Item
													</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							)}
							{isEdit && (
								<div
									className={
										styles['preview-container__main-add-rule__content']
									}
								>
									<table className={styles['preview-container__main-table']}>
										<thead>
											<tr
												className={styles['preview-container__main-table-row']}
											>
												<th>Employee</th>
												<th>Customers</th>
												<th>Class</th>
											</tr>
										</thead>
										<tbody>
											<tr
												className={styles['preview-container__main-table-row']}
												key={editActions?.key}
											>
												<td
													rowSpan={actions.length}
													style={{
														width: '20%',
													}}
												>
													{getSelectedEmployeeNames()}
												</td>
												<td
													style={{
														width: '30%',
													}}
												>
													<TreeSelect
														className={`${
															styles['preview-container__main-input']
														} ${
															editValidation.customerId &&
															'preview-container__main-input-error'
														}`}
														dropdownStyle={{
															maxHeight: 400,
															overflow: 'auto',
														}}
														size="large"
														placeholder="Customer"
														value={editActions?.customerId}
														showSearch={true}
														treeData={finalCustomerList}
														treeDefaultExpandAll
														onChange={(value: any, data: any) => {
															handleActions(
																'customerId',
																value,
																editActions?.key,
																'customerName',
																data[0]
															);
														}}
														filterTreeNode={(inputValue, treeNode) => {
															// Customize the filtering logic here
															return treeNode.props.title
																.toLowerCase()
																.includes(inputValue.toLowerCase());
														}}
													/>
												</td>
												<td
													style={{
														width: '30%',
													}}
												>
													<Select
														className={`${
															styles['preview-container__main-input']
														} ${
															editValidation.classId &&
															'preview-container__main-input-error'
														}`}
														value={editActions?.classId}
														size="large"
														onChange={(value: any, data: any) => {
															handleActions(
																'classId',
																value,
																editActions?.key,
																'className',
																data.children
															);
														}}
													>
														{/* <Select.Option value="">Select Class</Select.Option> */}
														<Select.Option value="">Blank Class</Select.Option>
														{filteredClassList?.map(
															(singleClass: any, index: number) => {
																return (
																	<Select.Option
																		value={singleClass?.Id}
																		key={index}
																	>
																		{singleClass?.FullyQualifiedName}
																	</Select.Option>
																);
															}
														)}
													</Select>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							)}
						</div>
					)}

					<div className={styles['preview-container__main-buttons']}>
						<button
							className={styles['preview-container__main-buttons-cancel']}
							onClick={handleCloseModal}
						>
							Cancel
						</button>
						{(isEditRulePermission || isAddRulePermission) && (
							<button
								className={`${styles['preview-container__main-buttons-save']} ${
									(isLoading || isError) && 'pointer-event-none'
								}`}
								onClick={handleSubmit}
							>
								{isLoading ? (
									<img src="/assets/gifs/loading-black.gif" height={40} />
								) : modalData && !isCopy ? (
									'Update'
								) : (
									'Save'
								)}
							</button>
						)}
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default AddRuleModal;
